import React from 'react';
import { observer } from "mobx-react";
import { CaretDownFilled } from '@ant-design/icons';
import { Dropdown } from 'antd';
import { theme } from '../theme';

const TournamentSelector = observer(class TournamentSelector extends React.Component {
	render() {
		const { tournamentID, tournaments, onChange } = this.props;
		const allLabel = this.props.allLabel || 'All Tourneys';
		const items = [
			{
				key: 'all',
				label: (
					<div style={{ fontSize: 26 }}>
						{allLabel}
					</div>
				),
			},
			...(tournaments || []).map((tournament) => ({
				key: tournament.id,
				label: (
					<div style={{ fontSize: 26 }}>{tournament.name || tournament.id}</div>
				),
			})),
		];
		const selected =
			tournamentID === 'all'
				? allLabel
				: (tournaments || []).find((t) => t.id === tournamentID);
		const compact = this.props.compact;
		const fillWidth = this.props.fillWidth;
		const inHeader = this.props.inHeader;

		return (
			<div
				className={inHeader ? 'tournamentSelector tournamentSelector--header' : undefined}
				style={{ marginTop: compact || fillWidth || inHeader ? 0 : 5, width: fillWidth || compact || inHeader ? '100%' : undefined }}
			>
				<Dropdown
					menu={{
						items,
						onClick: ({ key }) => onChange(key),
						style: { width: 260 },
					}}
					trigger={['click']}
				>
					<div
						style={{
							height: inHeader ? 32 : compact ? 38 : 45,
							borderRadius: 10,
							marginTop: compact || fillWidth || inHeader ? 0 : -5,
							marginLeft: compact || fillWidth || inHeader ? 0 : 5,
							fontSize: inHeader ? 14 : compact ? 16 : 22,
							cursor: 'pointer',
							backgroundColor: theme.surface,
							border: `1px solid ${theme.border}`,
							padding: inHeader ? '2px 8px' : compact ? '4px 6px' : '5px 8px',
							width: fillWidth ? '100%' : undefined,
							minWidth: fillWidth ? 0 : inHeader ? 148 : compact ? 130 : 200,
							maxWidth: fillWidth ? undefined : inHeader ? undefined : compact ? 150 : 320,
							alignItems: 'center',
							justifyContent: 'flex-start',
							color: theme.navy,
							boxShadow: theme.shadow,
						}}
						className="flexRow tournamentSelectorTrigger"
					>
						<span
							style={{
								flex: inHeader ? '0 1 auto' : 1,
								textAlign: 'left',
								overflow: inHeader ? 'visible' : 'hidden',
								textOverflow: inHeader ? 'clip' : 'ellipsis',
								whiteSpace: 'nowrap',
								color: theme.navy,
							}}
						>
							{tournamentID === 'all'
								? allLabel
								: selected
								? selected.name || selected.id
								: 'Select tournament'}
						</span>
						<CaretDownFilled style={{ flexShrink: 0, marginLeft: 4, color: theme.slate }} />
					</div>
				</Dropdown>
			</div>
		);
	}
});

export default TournamentSelector;
